import { ComponentReference } from "../interfaces/CoObject";
import React, { FunctionComponent } from "react";
import { Stack } from "@fluentui/react";

export interface ObjectComponentReferenceInfoProps {
  componentReference: ComponentReference;
}

export const ObjectComponentReferenceInfo: FunctionComponent<ObjectComponentReferenceInfoProps> = (
  props: ObjectComponentReferenceInfoProps
) => {
  const { componentReference } = props;
  return (
    <>
      <div style={{ marginTop: "4px" }}>Instance of:</div>
      <div>
        <Stack horizontal horizontalAlign="space-between">
          <div>
            {componentReference.componentName}
            <span className="component_item_icon">{"  "}</span>
          </div>
          <div className="component_item_row_doc_name">{componentReference.componentDocumentName}</div>
        </Stack>
      </div>
    </>
  );
};
